module.exports = __webpack_public_path__ + "img/marker-icon-am-go-2x.6a8a84c5.png";